export default {
  updateProfileImage: (params) => ({
    type: params.actionType,
    payload: params.payload,
  }),
  updateBlobURL: (params) => ({
    type: params.actionType,
    payload: params.payload,
  }),
  updateUnusedUrls: (params) => ({
    type: params.actionType,
    payload: params.payload,
  }),
};
